module.exports = __webpack_public_path__ + "static/media/2019_IMG_2045.b7aec4d8.jpg";